import React from "react";
import { useParams, Navigate } from "react-router-dom";
import StaffAttendance from "views/admin/participants/StaffAttendance";

const CenterStaffAttendance = () => {
  const { centerId } = useParams<{ centerId: string }>();

  if (!centerId) return <Navigate to="/systemadmin/centers" replace />;

  return <StaffAttendance centerId={centerId} />;
};

export default CenterStaffAttendance;
